import React from 'react'
import styled from 'styled-components'
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from 'reactstrap'
import { FaEllipsisV, FaRegTrashAlt } from 'react-icons/fa'

import { FONTS } from '../../../constants'

const DropdownActions = ({ handleClickDelete }) => {
  return (
    <ButtonDropdown>
      <Toggle>
        <FaEllipsisV style={ { fontSize: FONTS.NORMAL_SIZE } } />
      </Toggle>
      <DropdownMenu>
        <MenuItem onClick={ handleClickDelete }>
          <FaRegTrashAlt style={ {
            fontSize: FONTS.NORMAL_SIZE,
            color: '#C4C4C4',
          } }
          />
          Delete this data
        </MenuItem>
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export const EditPaneTab = ({ activeTab, handleClickTab, handleClickDelete }) => {
  return (
    <Root>
      <Wrapper>
        <Item
          active={ activeTab === 0 }
          onClick={ () => handleClickTab(0) }
        >
          Personal Info.
        </Item>
        <Item
          active={ activeTab === 1 }
          onClick={ () => handleClickTab(1) }
        >
            Company
        </Item>
        <Item
          active={ activeTab === 2 }
          onClick={ () => handleClickTab(2) }
        >
          Movements
        </Item>
        <Item
          active={ activeTab === 3 }
          onClick={ () => handleClickTab(3) }
        >
          Privilege Role
        </Item>
      </Wrapper>
      <DropdownActions handleClickDelete={ handleClickDelete } />
    </Root>
  )
}

const Root = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1;
`

const Item = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px;
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.SMALL_SIZE};
    color: ${p => (p.active ? '#D44B49' : '#808080')};
    border-bottom: ${p => (p.active ? '2px solid #D44B49' : 'none')};
    cursor: pointer;
    ${p => p.active && `
        margin-bottom: -2px;
    `}

    :nth-child(1) {
        margin-left: 0;
    }
`

const Wrapper = styled.div`
  display: flex;
`

const ButtonDropdown = styled(UncontrolledButtonDropdown)`
  margin-right: 18px;

  .dropdown-item {
    margin: 0;

    :active {
      background: #F1F1F1;
      color: #1A1A17;
    }

    :focus {
      outline: none;
    }
  }
`

const MenuItem = styled(DropdownItem)`
  display: flex;
  align-items: center;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #1A1A17;

  svg {
    margin-right: 12px;
  }
`

const Toggle = styled(DropdownToggle)`
  width: 26px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #EAEAEA;
  border-radius: 4px !important;;
  background: transparent;
  outline: none;
  color: #333333;
  padding: 0;

  :hover, :active, :focus {
    box-shadow: none;
    border-radius: 4px !important;
    background: transparent !important;
    color: #333333 !important;
    outline: none !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/tab.js